export default "__VITE_ASSET__B$JFw9gl__"